<template>
    <tr :class="getRowClass(rowData)"><th v-for="(columnDetails, id) in tableColumns" :class="columnDetails.cellClass"><slot></slot>{{columnDetails.cellData}}</th></tr>
</template>

<script>
    export default {
        props: {
            reportItems: {
                type: Array|Object,
                required: true
            },
            rowData: {
                type: Array|Object,
                required: true
            },
            country: {
                type: String,
                required: false
            }
        },
        mounted() {

        },
        computed: {
            isHidden: function (itemName) {
                return !this.getVisibility(this.reportItems, itemName);
            },
            tableColumns: function () {
                return this.getTableColumns(this.reportItems, this.rowData);
            },
            rowClass: function () {
                return this.rowClass(this.rowData, this.reportItems);
            },
            cellClass: function (itemName) {
                return this.getCellClass(this.rowData, this.reportItems, itemName);
            },
            cellData: function (itemName) {
                return this.getCellData(this.rowData, this.reportItems, itemName);
            }
        },
        methods: {
            getCellData: function (rowData, reportItems, itemName) {
                 let text = '';
                switch (rowData.rowType) {
                    case "header-text":
                        text = reportItems[itemName].label;
                        break;
                    default:
                        text = rowData.vehicle[itemName];
                }
                return text
            },
            getCellClass: function (rowData, reportItems, itemName) {
                let cssClass = '';
                let dataType = reportItems[itemName].datatype;
                let rowType = rowData.rowType;
                if (rowType.startsWith('group-title') || false) {
                    cssClass = rowType;
                } else {
                    cssClass = rowType + '-' + dataType;
                }
                if (rowType.startsWith('header')) {
                    cssClass = cssClass + ' ' + 'header';
                }
                return cssClass;
            },
            getRowClass: function (rowData) {
                let cssClass = '';
                if (rowData.rowType.startsWith('header')) {
                    cssClass = 'header';
                }
                return cssClass;
            },
            getVisibility: function (reportItems, itemName) {
                return reportItems[itemName].hidden = true;
            },
            getTableColumns: function (reportItems, rowData) {
                let tableColumns = [];
                let rowType = rowData.rowType;
                if (rowType.startsWith('group-title-')) {rowType = 'group-title'}
                 for (const [itemName, itemObject] of Object.entries(reportItems)) {
                    let cellData = this.getCellData(rowData, reportItems, itemName);
                    let cellClass = this.getCellClass(rowData, reportItems, itemName);
                    /** Handle hidden items that are part of a group */
                    if (itemObject.group) {
                        /** The value for the group property defines the hierarchie within the groups */
                        if (itemObject.group === 1) {
                            let headerText = ''
                            if (rowType === 'header-text') {
                                headerText = this.country;
                            }
                            tableColumns.push({itemName: itemName, cellData: headerText, cellClass: cellClass, colspan: 20});
                        }
                    } else {
                        if (!itemObject.hidden) {
                            let isVisibleForThisCountry = true;
                            if (itemObject.restrict) {
                                if (itemObject.restrict.countries) {
                                    isVisibleForThisCountry = itemObject.restrict.countries.includes(this.country);
                                }
                            }
                            if (isVisibleForThisCountry) {
                                tableColumns.push({itemName: itemName, cellData: cellData, cellClass: cellClass, colspan: 1});
                            }
                        }
                    }
                }
                return tableColumns;
            }
        }
    }
</script>

<style scoped>

</style>
